@use "@fukuri-admins/ui/layout" as *;

.wrapper {
  min-width: 343px;
  min-height: 80px;
  padding: spacing('8') spacing('12') spacing('8') spacing('8');
  border-radius: borderRadius('md');
  position: relative;

  &.info {
    background-color: background('Sky');
  }

  &.success {
    background-color: background('Green');
  }

  &.error {
    background-color: background('Red');
  }

  &.warning {
    background-color: background('Orange');
  }
}

.compact {
  min-height: auto;
}

.icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    color: currentColor;
  }
  &.iconInfo {
    color: text('Link');
  }
  &.iconSuccess {
    color: text('Green');
  }
  &.iconError {
    color: text('Red');
  }
  &.iconWarning {
    color: text('Orange');
  }
}

.content {
  display: flex;
  align-items: flex-start;
  gap: spacing('8');
  margin-right: spacing('32');
}

// titleかdescriptionどちらかがない場合の配置を実現するためにgridを使用
.textContainer {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas:
    "title action"
    "description description";
  align-items: start;

  &:not(:has(.title)) {
    grid-template-areas: "description action";
  }

  &:not(:has(.description)) {
    grid-template-areas: "title action";
  }
}

.textWrapper {
  min-height: 32px;
  display: flex;
  align-items: center;
  padding: 5px spacing('0');
}

.titleWrapper {
  grid-area: title;
}

.descriptionWrapper {
  grid-area: description;
}

.title {
  @include typography('Jp/14_W6');
  color: text('High');
}

.description {
  @include typography('Jp/14_W3');
  color: text('Low');
}

%focus-visible {
  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: spacing('2') solid border('Focus');
    box-shadow: 0 0 0 spacing('2') border('Focus');
    border-radius: spacing('2');
  }
}

.action {
  @extend %focus-visible;
  grid-area: action;
  align-self: start;
  margin-top: 5px;
  border: none;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
  @include typography('Jp/14_W3');
  color: text('Link');
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.closeButton {
  @extend %focus-visible;
  position: absolute;
  top: spacing('12');
  right: spacing('8');
  flex-shrink: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: spacing('4');
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: spacing('4');
  transition: background-color 0.2s;
  svg {
    color: currentColor;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
